module.exports = __webpack_public_path__ + "static/media/icon-energy.82cf5334.svg";